<template>
  <d-col cols="12" md="4" lg="4">
    <label for="brand">
      {{ $t('order.brand.brand') }}:
    </label>

    <div :class="{ 'form-control': true, 'is-select': true }">
      <v-select
        :options="brands"
        v-model="brand"
        :placeholder="$t('order.brand.enterBrand')"
        :taggable="true"
        @search="debouncedFetchBrands">
        <template slot="no-options">
          <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
          <template v-if="emptyResults">{{ $t('order.brand.noBrandsMatchingPhrase') }}&hellip;</template>
        </template>
      </v-select>
    </div>
  </d-col>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'order-select-brand',
  watch: {
    loadError (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-error');
      }
    },
    loadedBrands (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-success', 'brands');
      }
    }
  },
  data () {
    return {
      brand: '',
      loadedBrands: false,
      brands: [],
      loadError: false,
      emptyResults: false
    }
  },
  mounted () {
    FormUtils.loadAdditionalData(this, {
      endpoint: '/orders/search-brands',
      loadedKey: 'loadedBrands',
      outputKey: 'brands',
      errorKey: 'loadError',
      responseKey: 'brands',
      params: {
        search: ''
      },
      noPagination: true
    });
  },
  methods: {
    fetchBrands (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/search-brands',
        outputKey: 'brands',
        responseKey: 'brands',
        errorKey: 'loadError',
        noPagination: true,
        params: {
          search: searchPhrase
        },
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchBrands: debounce(function (searchPhrase, loadingCallback) {
      this.fetchBrands(searchPhrase, loadingCallback);
    }, 500)
  }
}
</script>
